import React from 'react'
import styled from 'styled-components';

const CustomerRefContainerStyle = styled.div`
    width: 100%;
    display:grid;
    justify-items: center;
    grid-template-columns: 1fr 1fr 1fr;

    @media all and (max-width: 1400px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    @media all and (max-width: 1247px) {
        display: grid;
        grid-template-columns: 1fr;
    }

    @media all and (max-width: 725px) {
        margin-top: -2em;
    }

`;

const CustomerRefContainer:React.FC = ({children}) => {
    return (
        <CustomerRefContainerStyle>
            {children}
        </CustomerRefContainerStyle>
    )
}

export default CustomerRefContainer
